import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import * as json from '../../../../assets/mock/products.json';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-poe-injector-list',
  templateUrl: './poe-injector-list-list.component.html',
  styleUrls: ['./poe-injector-list-list.component.less']
})
export class PoeInjectorListComponent implements OnInit {
  public electricalTable = [];
  public products = [];
  public product = {};
  public newColor = {};
  public lg;
  public queryParams;
  public env = environment;
  public host;
  constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.products = JSON.parse(JSON.stringify(json.products));
    this.product = this.products[5];
    this.host = this.env.getHost();
    this.route.queryParams.subscribe( queryParams => {
      this.lg = this.env.lang;
      this.queryParams = this.env.queryParams;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    });
    this.electricalTable = json.poe_injector_table;
    let colorVal = true;
    for (const j of this.electricalTable) {
      for (const key of j.ports) {
        for (const k of key.value) {
          const item = this.getNsbox(k, key.type);
          if (item) {
            this.newColor[k + key.type] = colorVal;
            colorVal = !colorVal;
          }
        }
      }
    }
  }

  getNsbox(name, type) {
    const result = this.products[5].catalog.find(item => (item.name === name && item.type === type && !(item.blocked && item.blocked.indexOf(this.host) > -1)));
    if (result && result.sets) {
       result.sets = result.sets.filter(item => !(item.blocked && item.blocked.indexOf(this.host) > -1));
    }
    return result;
  }

  haveElement(port) {
    for (const i of port.value) {
      if ( this.getNsbox(i, port.type) && this.getNsbox(i, port.type).sets.length) {
        return true;
      }
    }
    return false;
  }
}
